var map = {
	"./bubinga-mask.png": "2870",
	"./mahogany-mask.png": "03d4",
	"./maple-mask.png": "f42d",
	"./oak-mask.png": "c098",
	"./originals/maple-mask.png": "462b",
	"./originals/oak-mask.png": "5f17",
	"./originals/poplar-mask.png": "1fd2",
	"./padauk-mask.png": "49c1",
	"./poplar-mask.png": "2777",
	"./purpleheart-mask.png": "af11",
	"./zebrawood-mask.png": "565a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d3e";